module.exports = __webpack_public_path__ + "static/media/pro.438737b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pro.jpg
// module id = 832
// module chunks = 0